/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import ForgotPassword from "./ForgotPassword";

/* Render ForgotPassword app into the pug template, pulling props from global window */
function render(props) {
  hydrate(<ForgotPassword {...props} />, document.getElementById("react"));
}
render(window.reactProps);
